import {makeStyles} from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  hidden: {
    visibility: 'hidden',
    width: 0,
    height: 0,
    padding: 0,
    border: 'none',
    margin: 0,
  },
  root: {
    width: 'auto',
    marginBottom: 0,
    cursor: 'pointer',
  },
}))

export default useStyles
